import styles from "../WorkoutAdminModal.module.css";

export default function TabButton({ active, onClick, children }) {
return (
  <button
    type="button"
    role="tab"
    aria-selected={active}
    className={`${styles.wamTab} ${active ? styles.active : ""}`}
    onClick={onClick}
  >
    {children}
  </button>
);
}
